import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  body: {
    password: string;
    passwordConfirmation: string;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>("/api/admin_operator_authenticate/password", {
      ...body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisAdminOperatorAuthenticatePasswordUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
